'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'language';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f1ab';
var svgPathData = 'M456 164C467 164 476 172.1 476 184V188H536C547 188 556 196.1 556 208C556 219 547 228 536 228H534L532.4 232.5C523.5 256.1 509.9 279.1 492.7 297.9C493.6 298.4 494.5 298.1 495.4 299.5L514.3 310.8C523.8 316.5 526.8 328.8 521.1 338.3C515.5 347.8 503.2 350.8 493.7 345.1L474.8 333.8C470.4 331.1 465.1 328.3 461.7 325.3C451.2 332.8 439.8 339.3 427.8 344.7L424.1 346.3C414 350.8 402.2 346.2 397.7 336.1C393.2 326 397.8 314.2 407.9 309.7L411.5 308.1C417.9 305.2 424.1 301.1 430 298.3L417.9 286.1C410 278.3 410 265.7 417.9 257.9C425.7 250 438.3 250 446.1 257.9L460.7 272.4L461.3 272.1C473.7 259.9 483.8 244.7 491.1 227.1H384C372.1 227.1 364 219 364 207.1C364 196.1 372.1 187.1 384 187.1H436V183.1C436 172.1 444.1 163.1 456 163.1L456 164zM140.1 276L160 233.2L179 276H140.1zM576 64C611.3 64 640 92.65 640 128V384C640 419.3 611.3 448 576 448H64C28.65 448 0 419.3 0 384V128C0 92.65 28.65 64 64 64H576zM576 112H320V400H576C584.8 400 592 392.8 592 384V128C592 119.2 584.8 112 576 112zM178.3 175.9C175.1 168.7 167.9 164 160 164C152.1 164 144.9 168.7 141.7 175.9L77.72 319.9C73.24 329.1 77.78 341.8 87.88 346.3C97.97 350.8 109.8 346.2 114.3 336.1L123.2 315.1H196.8L205.7 336.1C210.2 346.2 222 350.8 232.1 346.3C242.2 341.8 246.8 329.1 242.3 319.9L178.3 175.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLanguage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;